import React, { useState, memo } from 'react'
import { checkImgWidth } from '../../utils/utils'
import styled, { createGlobalStyle } from 'styled-components'
// import Zmage from 'react-zmage'
import { Image } from 'antd';

const GlobalStyle = createGlobalStyle`
  #zmageControl {
    position: fixed;
    right: 20%;
    top: 20%;
    z-index: 1000;
  }
  #zmageImage {
    transform: none!important;
  }
`

const ImgWrapper = styled.div`
  margin-top: 8px;
`

const RenderImgMsg = memo((props) => {
  const { value } = props
  let message = value.messageContent ? JSON.parse(value.messageContent) : {}
  const [imgWidth, setImgWidth] = useState(255)
  const [imgHeight, setImgHeight] = useState(255)
  checkImgWidth(message.url).then(({ width, height }) => {
    const maxWidth = 255
    const maxHeight = 255
    if (width >= height && width >= maxHeight) {
      setImgWidth(maxWidth)
      setImgHeight(maxWidth * height / width)
    }
    if (height > width && height >= maxHeight) {
      setImgHeight(maxHeight)
      setImgWidth(maxHeight * width / height)
    }
  })
  return (
    <ImgWrapper>
      <GlobalStyle />
      {/* <Zmage src={message.url} width={imgWidth} height={imgHeight} alt='图片' defaultPage={0}
        controller={{ close: true, zoom: false, download: false, rotate: false }}
        set={[{
          src: message.url, alt: "图片",
          style: {
            position: "fixed",
            top: `calc(50% - ${imgHeight}px)`,
            left: `calc(50% - ${imgWidth}px)`,
            width: imgWidth * 2,
            height: imgHeight * 2,
          }
        }]} /> */}
      <Image
        width={imgWidth}
        height={imgHeight}
        src={message.url}
        alt="图片"
      />
    </ImgWrapper>
  )
})

export default RenderImgMsg
